<template>
  <div>
    <v-container grid-list-lg>
      <v-layout justify-space-around row wrap>
        <v-flex xl3 lg4 md4 sm6>
          <apexchart type="bar" :options="ageData.options" :series="ageData.series"></apexchart>
        </v-flex>
        <v-flex xl3 lg4 md4 sm6>
          <apexchart type="donut" :options="rankData.options" :series="rankData.series" style="margin-bottom:-25%">
          </apexchart>
        </v-flex>
        <v-flex xl3 lg4 md4 sm6>
          <apexchart type="donut" :options="genderData.options" :series="genderData.series" style="margin-bottom:-25%">
          </apexchart>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex";
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters({
        ageData: "getAgeData",
        rankData: "getRankData",
        genderData: "getGenderData"
      })
    }
  };
</script>

<style>
</style>